import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {standardActions} from "../../../Utils/Grid/StandardActions";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";

export default class MedidasList extends Component{
    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="Medidas"
                    subtitulo="">
                    <Header to="medida/crear" textBtn="CREAR MEDIDA" {...this.props} />
                    <Grid hover striped data={data} loading={loader} page={page} onPageChange={onPageChange}>
                        <TableHeaderColumn
                            dataField="id"
                            dataSort
                            width='20%'
                        >
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            isKey
                            dataField="nombre"
                            dataSort
                            width='20%'
                        >
                            Nombre
                        </TableHeaderColumn>
                       
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "medida", eliminar})}
                        >
                            Acciones
                        </TableHeaderColumn>
                    </Grid>
                </Card>
            </div>
        )
    }
}
